import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {AllowedUrlParams} from '../../types/AllowedUrlParams'
import {getAllowedUrlParams} from '../../app/thunk'

export const generalSlice = createSlice({
    name: 'general',
    initialState: {
        featureAppId: '',
        backendUrl: '',
        previewDateParam: '',
        serviceType: '',
        loading: false,
        ctaAllowedParams: [] as AllowedUrlParams[],
    },
    reducers: {
        setFeatureAppId(state: RootState, action: PayloadAction<string>): void {
            state.featureAppId = action.payload
        },
        setBackendUrl(
            state: RootState,
            action: PayloadAction<string | undefined>
        ): void {
            state.backendUrl = action.payload
        },
        setPreviewDateParam(
            state: RootState,
            action: PayloadAction<string | undefined>
        ): void {
            state.previewDateParam = action.payload
        },
        setServiceType(state: RootState, action: PayloadAction<string>): void {
            state.serviceType = action.payload
        },
        setLoading(state: RootState, action: PayloadAction<boolean>): void {
            state.loading = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(
            getAllowedUrlParams.fulfilled,
            (state: RootState, action) => {
                state.ctaAllowedParams = action.payload
            }
        )
    },
})

export const {
    setFeatureAppId,
    setBackendUrl,
    setPreviewDateParam,
    setServiceType,
    setLoading,
} = generalSlice.actions

export default generalSlice.reducer
